// Constants
export const ARTICLE_CATEGORIES = [
  "Market News",
  "Fund Launches & Closures",
  "Regulatory & Compliance",
  "Mergers & Acquisitions",
  "ESG & Sustainability",
  "Macro-Economic Analysis",
  "Technology & Innovation",
  "People Moves",
  "Wealth Management",
  "Investment Association",
];

export const ARTICLE_SOURCES = [
  "investment_week",
  "ft",
  "bbc",
  "yahoo_finance",
  "cnbc",
  "cnbc_markets",
  "marketwatch",
  "investing_com",
  "nasdaq",
  "economist",
  "citywire",
  "investments_pensions_europe",
];
